import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';

import { LinkComponentFragment, Maybe, PageComponentsFragment, InlineHubspotFormFragment } from '../../../graphql.schema';
import StrapiLink from '../StrapiLink/StrapiLink';
import StrapiButton from '../StrapiLink/StrapiButton';
import { RichTextField } from '../RichTextField/RichTextField';
import ModalButton from '../ModalButton/ModalButton';
import { StrapiInlineHubspotForm } from '../StrapiComponents';

import * as styles from './ContentBlock.module.scss';

export type ContentBlockProps = {
  titleOverride?: React.ReactNode;
  title?: string;
  titleClass?: string;
  content?: string;
  contentClass?: string;
  links?: Maybe<LinkComponentFragment>[];
  linksClass?: string;
  button?: LinkComponentFragment;
  buttonClass?: string;
  icon?: 'Arrow' | 'Chevron';
  // Custom class name to add to the root component.
  className?: string;
  // Allows the content block to grow to the size of its container
  isFluid?: boolean;
  customRender?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement>;
  __typename?: string;
  component: NonNullable<PageComponentsFragment>;
  showFormInHeader?: boolean;
  inlineHubspotForm?: Maybe<InlineHubspotFormFragment>;
};

export const ContentBlock: React.FC<ContentBlockProps> = ({
  titleOverride,
  title,
  titleClass,
  content,
  contentClass,
  links,
  linksClass,
  button,
  buttonClass,
  className,
  isFluid = false,
  customRender,
  icon,
  __typename,
  component,
  showFormInHeader,
  inlineHubspotForm
}) => (
  <div className={classnames(styles.root, className, { [styles.isNotFluid]: !isFluid })}>
    {titleOverride ? titleOverride : title && <h2 className={classnames('title', titleClass ?? 'is-2')}>{title}</h2>}
    <RichTextField className={contentClass} content={content} />
    {customRender ? <div className={styles.heroFeatures}>{customRender}</div> : <></>}
    {showFormInHeader ? (<StrapiInlineHubspotForm title={inlineHubspotForm?.title} description={inlineHubspotForm?.description} html={inlineHubspotForm?.html} className={styles.headerForm} showFormInHeader={showFormInHeader} />) : 
    <>
    {links?.length ? (
      <div className={classnames(styles.links, linksClass)}>
        {links.map(
          (link) =>
            link &&
            (get(link, 'modal.data', link.modal) ? (
              <ModalButton icon={icon} modalButtonType="link" {...link} data-testid="testButton"/>
            ) : (
              <StrapiLink icon={icon} key={`contentBlockLinks-${link.id}`} {...link} data-testid="testLink"/>
            )),
        )}
      </div>
    ) : null}
    {button ? (
      <div className={classnames(__typename == 'Strapi_ComponentPageRichText' ? styles.richtextButton : '')} data-testid="testButton">
        <StrapiButton icon={icon} type="primary" {...button} />
      </div>
    ) : null}
    </>
    }
  </div>
);
